/**
 * Route: /developer — Story 5.2 (Developer-Portal)
 *
 * Konsolidiertes Developer-Portal gemaess claude-design-import/developer.html:
 * API-Key, Kontingent, API-Tokens und Webhooks auf EINER Seite. Die
 * v1-Unterseiten /developer/api-tokens und /developer/webhooks bleiben als
 * Deep-Links bestehen (u.a. fuer das Delivery-Log der Webhooks).
 */
import { createFileRoute } from '@tanstack/react-router'
import { DeveloperPortalPage } from '../features/developer/DeveloperPortalPage'

export const Route = createFileRoute('/_auth/developer/')({
  component: DeveloperPortalPage,
})
